import PropTypes from 'prop-types';
import React from 'react';
import 'intl';
import 'intl/locale-data/jsonp/en';
import url from 'url';
import moment from 'moment';
import 'moment/locale/es'
import 'moment/locale/ru'
import reactTInit from '../../components/reactT/reactTInit';
import reactT from '../../components/reactT';

const langcode = document.querySelector('html').getAttribute('lang');
moment.locale(langcode);
moment.updateLocale(langcode, {
  longDateFormat: {
      L: "MM/DD/YYYY",
  }
});

// Custom class for the result component
class FederatedResult extends React.Component {
  renderValue(field, doc) {
    const value = [].concat(doc[field] || null).filter((v) => v !== null);

    return value.join(", ");
  }

  dateFormat(date){
    if (typeof date !== undefined) {
      const prettyDate =  new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(Date.parse(date));
      const separator = "  ·  ";
      return separator + prettyDate;
    }
  }

  dateMomentFormat(date){
    if (typeof date !== undefined) {
      return moment(Date.parse(date)).format('MMMM Y');
    }
  }

  /**
   * Returns the appropriate link for a given search result.
   * 1. Use the canonical url if present.
   * 2. Next, attempt to find a url from the current host.
   * 3. Then, use the first url returned in the array of urls.
   * 4. Fall back to the legacy url field.
   * 5. Send an empty string if none of these options work.
   *
   * @param doc
   *   Search result object
   * @returns string
   */
  getCanonicalLink(doc) {
    const { hostname } = this.props;

    // 1. Use the canonical url as a first option
    if (Object.hasOwnProperty.call(doc, 'ss_canonical_url') && doc.ss_canonical_url) {
      return doc.ss_canonical_url;
    }

    // Use a url from the current host, if present.  Otherwise use the first Url.
    if (Object.hasOwnProperty.call(doc, 'sm_urls') && Array.isArray(doc.sm_urls)) {
      // Attempt to find a url from the current host.
      const currentHostUrl = doc.sm_urls.find((item) => {
        const myUrl = url.parse(item);
        return myUrl.hostname === hostname;
      });

      // 2. Use the url from the current host.
      if (currentHostUrl) {
        return currentHostUrl;
      }

      // 3. Use the first url.
      return doc.sm_urls[0];
    }

    // 4. Fall back to the single url (which will be relative)
    if (Object.hasOwnProperty.call(doc, 'ss_url') && doc.ss_url) {
      return doc.ss_url;
    }

    // 5. If no valid urls are passed, return nothing. This will result in an
    // unlinked title, but at least it won't crash.
    return '';
  }

  intersperse(arr, sep) {
    if (arr.length === 0) {
      return [];
    }

    return arr.slice(1).reduce(function(xs, x, i) {
      return xs.concat([sep, x]);
    }, [arr[0]]);
  }

  renderSitenameLinks(sitenames, urls, originalSitename) {
    if (sitenames !== null && urls !== null) {

      var sites = [];
      for (var i = 0; i < sitenames.length; i++) {
        sites.push(<a className="search-results__site-name" href={urls[i]} key={i}>{sitenames[i]}</a>);
        if (i !== (sitenames.length - 1)) {

        }
      }
      return this.intersperse(sites, " | ");
    }

    if (originalSitename !== null) {
      return originalSitename;
    }

    return null;
  }

  render() {
    reactTInit();
    const { doc, highlight } = this.props;

    let name = 
    <div
    className="field field--name-node-title field--type-ds field--label-hidden field__item"
  >
    <h3 className="d-inline small-h3">
    {doc.ss_external_link !== undefined && doc.ss_external_link !== null && doc.ss_external_link !== '' ? <a href={doc.ss_external_link}
      target="_blank"
      rel="noopener noreferrer"
   >{doc.ss_origin_title}</a> : doc.ss_origin_title}
</h3>
  </div>;

    let excerpt = '';
    let body = '';
  
  if (langcode === "en") {
    if (doc.tm_X3b_en_body !== undefined && doc.tm_X3b_en_body !== null && doc.tm_X3b_en_body !== ''){
    body = doc.tm_X3b_en_body;
    }
  } else if (langcode === "es") {
    if (doc.tm_X3b_es_body !== undefined && doc.tm_X3b_es_body !== null && doc.tm_X3b_es_body !== ''){
      body = doc.tm_X3b_es_body;
      }
  } else if (langcode === "ru") {
    if (doc.tm_X3b_ru_body !== undefined && doc.tm_X3b_ru_body !== null && doc.tm_X3b_ru_body !== ''){
      body = doc.tm_X3b_ru_body;
      }
  }  
  
  if (highlight[Object.keys(highlight)[0]] !== undefined && highlight[Object.keys(highlight)[0]] !== null && highlight[Object.keys(highlight)[0]] !== '') {
    excerpt=
        <div className="field--name-body mb-15 color-brownish-gray text-sm">
        <p dangerouslySetInnerHTML={{__html: highlight[Object.keys(highlight)[0]]}}/>
      </div>
  }
  else {
    excerpt=
    <div className="field--name-body mb-15 color-brownish-gray text-sm">
    <p dangerouslySetInnerHTML={{__html: body}}/>
  </div>
  }
  
  let link = '';
  if (doc.ss_external_link !== undefined && doc.ss_external_link !== null && doc.ss_external_link !== '') {
    if (doc.ss_external_link.includes("internal:")) {
      doc.ss_external_link = doc.ss_external_link.replace('internal:','');
    }

    link =
    <div
    className="field field--name-field-link field--type-link field--label-hidden field__item"
  >
    <a
      href={doc.ss_external_link}
      className="btn btn-secondary btn-sm border border-secondary"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="ext-link-icon"></div>
      {reactT("Visit link")}
    </a>
  </div>;
  }

    return (
      <article
        className="contextual-region node node--type-external-link node--view-mode-text-teaser-small text-teaser-view-mode small anchor-all clearfix"
      >
        <div className="main-content">
            {name}
            {excerpt}
            {link}
        </div>
      </article>
    );
  }
}

FederatedResult.propTypes = {
  doc: PropTypes.object,
  fields: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
    hostname: PropTypes.string,
};

export default FederatedResult;
